module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_BEAM.263e4fcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_BEAM.png
// module id = 45
// module chunks = 0